import React, {Component} from 'react';
import PropTypes from 'prop-types';

import axios from 'axios';
import {getAvailableTariffs} from './api';
import Tariff from './Tariff';

const {CancelToken} = axios;

class TariffsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      packages: [],
    };
  }

  componentDidMount() {
    this.getTariffsSource = CancelToken.source();
    getAvailableTariffs(this.getTariffsSource.token)
      .then((packages) => {
        this.setState({
          packages,
        });
      });
  }

  componentWillUnmount() {
    this.getTariffsSource.cancel('Tariff Container will umnount');
  }

  render() {
    const {packages} = this.state;
    const {handleSelect, company, plan, user} = this.props;
    return (
      <div className="tariffContainer">
        <div className='tariffsListWrapper'>
          <ul className='tariffsList' id="tariff-containers">
            {
              packages.slice().reverse().map(curPackage => (
                <li
                  className={"itemWrapper"}
                  key={curPackage.id}
                >
                  <Tariff company={company}
                          tariff={curPackage}
                          handleSelect={handleSelect}
                          plan={plan}
                          user={user}
                  />
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    );
  }
}

TariffsContainer.propTypes = {
  selected: PropTypes.shape({
    packageId: PropTypes.string,
    additionalClients: PropTypes.number,
    additionalOperators: PropTypes.number,
  }),
  plan: PropTypes.object,
  handleSelect: PropTypes.func.isRequired,
  company: PropTypes.object
};

TariffsContainer.defaultProps = {
  selected: {
    packageId: '-1',
    additionalClients: 0,
    additionalOperators: 0,
  },
};

export default TariffsContainer;



// WEBPACK FOOTER //
// ./src/components/tariff/TariffsContainer.jsx